import { render } from "./areaecoSelf.vue?vue&type=template&id=68cd3088&scoped=true"
import script from "./areaecoSelf.vue?vue&type=script&lang=js"
export * from "./areaecoSelf.vue?vue&type=script&lang=js"

import "./areaecoSelf.vue?vue&type=style&index=0&id=68cd3088&lang=scss&scoped=true"

import exportComponent from "E:\\项目\\经济运行\\econo-eco-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68cd3088"]])

export default __exports__